// removed by extract-text-webpack-plugin
module.exports = {"recipePage":"_10j_T1fQ5WRTc_atibe8lX","title":"_1Y9fAxbGNR7Q1xiocL6t6Q","sidebar":"_2Fh-mPtISu-57DlU4irri4","recipePanel":"_1O9ELHIW07FCgRwCKW-O9Y","spacer5":"_21ggBMrZjEQQV0IUTd_nMS","spacer10":"_4QtXJezlbnSctn9bELYXU","spacer15":"_1AT2FJN47_3BwNVQK6_lRf","spacer20":"_6pYtCmNUszHeqS7VRzJMX","spacer25":"_2sE55Brn5tcLVHowcL3PEy","spacer30":"_2M2oA-VMDmxRdaFejvTYUi","spacer35":"no5_scWF17Wp6m82bKIjD","spacer40":"_1H6frH9I8C6xd3UPdVZaTn","spacer45":"_187KiQQ3jUBEVR47vg-OTk","spacer50":"_1kwX70RgG58pRzomhKBUjA","spacer100":"_2M3SAxnX-1azzqNKceDqUh","spacer200":"_1gBPsZ6ww3du8e2n3s_bij"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Recipes/Recipes.scss
// module id = 145
// module chunks = 0